export default __webpack_public_path__ + "static/media/contact.a4e93671.jpg";